import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';
import ReadWriteRecipientWellViewState from '../store/schema/ReadWriteRecipientWellViewState';
import { action, mutator } from 'satcheljs';

/**
 * Action for adding recipients in bulk
 * @param newRecipients New recipients to be added
 * @param recipientWellRecipients View state of recipient well
 */
const addRecipientsToRecipientWell = action(
    'addRecipientsToRecipientWell',
    (
        newRecipients: ReadWriteRecipientViewState[],
        recipientWellRecipients: ReadWriteRecipientWellViewState
    ) => ({
        newRecipients: newRecipients,
        recipientWellRecipients: recipientWellRecipients,
    })
);

export default addRecipientsToRecipientWell;

// Mutating recipientstatewell
mutator(addRecipientsToRecipientWell, actionMessage => {
    const { recipientWellRecipients } = actionMessage;

    recipientWellRecipients.recipients.splice(
        recipientWellRecipients.recipients.length,
        0,
        ...actionMessage.newRecipients
    );
    recipientWellRecipients.isDirty = true;
});
